import { render, staticRenderFns } from "./AbstractThankYouPage.vue?vue&type=template&id=213336b3"
import script from "./AbstractThankYouPage.vue?vue&type=script&lang=js"
export * from "./AbstractThankYouPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports